/* eslint-disable no-console */
import { get } from 'lodash';

import GearzettePageQuery from 'Query/GearzettePage.query';
import { setPostDetailsLoading, updateGearzettePostDetailResolver } from 'Store/GearzettePage';
import { updateNoMatch } from 'Store/NoMatch/NoMatch.action';
import { QueryDispatcher } from 'Util/Request';

/** @namespace Pwa/Store/GearzettePage/GearzettePostDetailResolver/Dispatcher/GearzettePostDetailResolverDispatcher */
export class GearzettePostDetailResolverDispatcher extends QueryDispatcher {
    __construct() {
        super.__construct();
    }

    // eslint-disable-next-line no-unused-vars
    onSuccess(response, dispatch, { cb }) {
        const postDetailResolver = get(response, 'post', {});
        dispatch(updateGearzettePostDetailResolver(postDetailResolver));
    }

    onError(_, dispatch) {
        dispatch(setPostDetailsLoading(false));
        dispatch(updateNoMatch(true));
    }

    prepareRequest(options, dispatch) {
        dispatch(setPostDetailsLoading(true));
        return GearzettePageQuery.getQueryPostDetailResolver(options);
    }
}

export default new GearzettePostDetailResolverDispatcher();
